import styled from "styled-components"

import { ApiTypes, UITypes } from "types"

import { ContentWrapper } from "components/common/ContentWrapper"
import { Pagination } from "components/common/Pagination"
import EditColumnsButton from "components/EditColumnsButton"
import { ButtonNew } from "components/form/ButtonNew"
import TableWrapper from "components/table/TableWrapper"

import { SensorsEmptyState } from "./SensorsEmptyState"

const HeaderButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

interface SensorsPageContentProps {
  data: UITypes.TableBodyRow[]
  tableHeaderCells: UITypes.TableHeaderCell[]
  isFetching: boolean
  listName: ApiTypes.Model.PageTableName
  tableName: string
  meta?: ApiTypes.Model.Pagination
  hasActiveFilters: boolean
  onExport: () => void
}

export const SensorsPageContent = ({
  data,
  tableHeaderCells,
  isFetching,
  listName,
  tableName,
  meta,
  hasActiveFilters,
  onExport,
}: SensorsPageContentProps) => {
  const isEmpty = !isFetching && meta?.total === 0 && !hasActiveFilters

  return (
    <ContentWrapper
      title="Sensors"
      renderHeaderAccessoryView={() => (
        <HeaderButtons>
          <EditColumnsButton tableName={listName} tableHeaderCells={tableHeaderCells} />
          <ButtonNew onClick={onExport} disabled={meta?.total === 0}>
            Export
          </ButtonNew>
        </HeaderButtons>
      )}
    >
      {isEmpty ? (
        <SensorsEmptyState />
      ) : (
        <>
          <TableWrapper
            tableName={tableName}
            headerCells={tableHeaderCells}
            data={data}
            isLoading={isFetching}
            columnsLoaded
            rowsExpanded
          />
          <Pagination meta={meta} />
        </>
      )}
    </ContentWrapper>
  )
}
